import { configureStore } from "@reduxjs/toolkit";
import { createTerminalMiddleware } from "@aerelontech/react-terminal";

import chartReducer from "./chartSlice";
import diagramReducer from "./diagramSlice";
import documentReducer from "./documentSlice";
import ganttReducer from "./ganttSlice";
import griddReducer from "./griddSlice";
import styleDraftReducer from "./styleDraftSlice";
import { persistenceListener } from "./persistenceListener";

export const store = configureStore({
  reducer: {
    document: documentReducer,
    gridd: griddReducer,
    // TODO §21/§4.3.1 Excalidraw scenes, keyed by diagramDocId. Out of `document` for the
    // same reason grid bodies are: the editor emits a whole scene per stroke.
    diagram: diagramReducer,
    // TODO §26/§3.3 SVAR gantt schedules, keyed by ganttDocId. Out of `document` for the
    // same reason the two above are.
    gantt: ganttReducer,
    // TODO §15/§3.3 Chart bodies — columns, rows and the encoding — keyed by chartDocId. Out
    // of `document` for the same reason the three above are, and one more: typing in a data
    // table dispatches per keystroke (§3.3.3).
    chart: chartReducer,
    // Session-only preview state — no persistence listener, no hydration (TODO §10.3).
    styleDraft: styleDraftReducer,
  },
  // `createTerminalMiddleware` streams every dispatched action into the AI terminal's feed
  // (packages/react-terminal) so the assistant — and the `/feed` command — can see what the
  // app is doing. It only observes; it never blocks or transforms an action.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(persistenceListener.middleware)
      .concat(createTerminalMiddleware()),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
